export enum presetVariants {
	GLOBAL = 'GLOBAL',
	LOCAL = 'LOCAL',
}
